import {useMutation} from '@apollo/client';

// Components
import Toast from 'utils/Alert/Toast/Toast';
import Modal from '../../../../../utils/Modal/Modal';
import CustomSpinner from 'utils/CustomSpinner/CustomSpinner';

// Utils
import {getError} from 'utils/helpers';
import {SECONDARY, SUCCESS} from '../../../../constants';
import {DELETE_ADMIN_USER} from 'api/mutations/adminUsers';

const DeleteUserModal = ({show, toggle, data}) => {
    const [deleteAdminUser, {loading}] = useMutation(DELETE_ADMIN_USER, {
        refetchQueries: ['getAdminUsers'],
        onCompleted: () => {
            Toast({
                msg: 'User deleted successfuly',
                position: 'top-right',
                variant: SUCCESS,
            });
            toggle();
        },
        onError: error => Toast({msg: getError(error), position: 'top-right'}),
    });

    return (
        <Modal type={SECONDARY} show={show} title="Remove User?" toggle={toggle}>
            <div className="text-center text--large-sm text--gray px-5">
                Are you sure you want to delete this User?
            </div>
            <div className="flex__between flex-wrap pt-5">
                <div className="col-sm-6 col-12 mt-3">
                    <div className="col-sm-11 col-12">
                        <button
                            disabled={loading}
                            onClick={toggle}
                            className="btn btn--lg btn--primary fw-bold"
                        >
                            No
                        </button>
                    </div>
                </div>
                <div className="col-sm-6 col-12 flex__end mt-3">
                    <div className="col-sm-11 col-12">
                        <button
                            disabled={loading}
                            onClick={() =>
                                deleteAdminUser({
                                    variables: {id: data?.id},
                                })
                            }
                            className="btn btn--lg btn--danger--bordered fw-bold"
                        >
                            {loading ? <CustomSpinner cls="btn--danger--bordered" /> : 'Yes'}
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteUserModal;
